import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Libreta from '../views/Libreta.vue'
import Cuenta from '../views/Cuenta.vue'
import Courier from '../views/Courier.vue'
import Agente from '../views/Agente.vue'
import Usuario from '../views/Usuario.vue'
import Empresa from '../views/Empresa.vue'
import Contacto from '../views/Contacto.vue'
import EstatusG from '../views/TipoEstatusGuia.vue'
import EstatusP from '../views/TipoEstatusPickup.vue'
import AgenteAsegurador from '../views/AgenteAsegurador.vue'
import MotivoUndel from '../views/MotivosUndel.vue'
import CargosAdicionales from '../views/CargosAdicionales.vue'
import Guias from '../views/Guias.vue'
import Pickups from '../views/Pickups.vue'
import Runsheets from '../views/Runsheet.vue'
import AsignacionEstatusMasiva from '../views/AsignacionEstatusMasiva.vue'
import TransmisionMasiva from '../views/TransmisionMasiva.vue'
import Importacion from '../views/Importacion.vue'
import Exportacion from '../views/Exportacion.vue'
import Nacional from '../views/Nacional.vue'
import CargarGuias from '../views/CargarGuias.vue'
import ActualizacionPODMasiva from '../views/ActualizacionPODMasiva.vue'
import MailTemplate from '../views/MailTemplate.vue'
import ComprasLinea from '../views/ComprasLinea.vue'
import ComprasLineaEstatus from '../views/ComprasLineaEstatus.vue'
import Rastreo from '../views/Rastreo.vue'
import ReporteImp from '../views/ReporteImportaciones.vue'
import ReporteExp from '../views/ReporteExportaciones.vue'
import ReporteSeg from '../views/ReporteSeguros.vue'
import ReporteImpUps from '../views/ReporteImportacionesUps.vue'
import ReporteReclamos from '../views/ReporteReclamos.vue'
import ReporteNacional from '../views/ReporteNacional.vue'
import ReporteGeneral from '../views/ReporteGeneral.vue'
import ReporteGeneralCli from '../views/ReporteGeneralCli.vue'
import ReportePickups from '../views/ReportePickups.vue'
import CargarManifiestoCL from '../views/CargarManifiestoCL.vue'
import CargarPodInfo from '../views/CargarPodInfo.vue'
import CargarTarifas from '../views/CargarTarifas.vue'
import RunsheetsCL from '../views/RunsheetsCL.vue'
import ActualizacionMasivaCL from '../views/ActualizacionMasivaCL.vue'
import IndicadoresCL from '../views/IndicadoresCL.vue'
import ReporteCL from '../views/ReporteCL.vue'
import EliminarManifiesto from '../views/EliminarManifiesto.vue'
import Cotizar from '../views/Cotizar.vue'
import CiudadEc from '../views/CiudadEc.vue'
import CodigosDescuento from '../views/CodigosDescuento.vue'
import ConfiguracionTasas from '../views/ConfiguracionTasas.vue'
import CargarPrecioTramite from '../components/CargarPrecioTramite.vue'
import ReporteCotizaciones from '../views/ReporteCotizaciones.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/libreta',
    name: 'libreta',
    component: Libreta,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuario',
    name: 'usuario',
    component: Usuario,
    meta: { requiresAuth: true }
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: Empresa,
    meta: { requiresAuth: true }
  },
  {
    path: '/cuenta',
    name: 'cuenta',
    component: Cuenta,
    meta: { requiresAuth: true }
  },
  {
    path: '/courier',
    name: 'courier',
    component: Courier,
    meta: { requiresAuth: true }
  },
  {
    path: '/contacto',
    name: 'contacto',
    component: Contacto,
    meta: { requiresAuth: true }
  },
  {
    path: '/estatusg',
    name: 'estatusg',
    component: EstatusG,
    meta: { requiresAuth: true }
  },
  {
    path: '/estatusp',
    name: 'estatusp',
    component: EstatusP,
    meta: { requiresAuth: true }
  },
  {
    path: '/agente',
    name: 'agente',
    component: Agente,
    meta: { requiresAuth: true }
  },
  {
    path: '/ciudadec',
    name: 'ciudadec',
    component: CiudadEc,
    meta: { requiresAuth: true }
  },
  {
    path: '/agentease',
    name: 'agentease',
    component: AgenteAsegurador,
    meta: { requiresAuth: true }
  },
  {
    path: '/motivoundel',
    name: 'motivoundel',
    component: MotivoUndel,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargosadicionales',
    name: 'cargosadicionales',
    component: CargosAdicionales,
    meta: { requiresAuth: true }
  },
  {
    path: '/guias',
    name: 'guias',
    component: Guias,
    meta: { requiresAuth: true }
  },
  {
    path: '/pickups',
    name: 'pickups',
    component: Pickups,
    meta: { requiresAuth: true }
  },
  {
    path: '/runsheets',
    name: 'runsheets',
    component: Runsheets,
    meta: { requiresAuth: true }
  },
  {
    path: '/runsheetscl',
    name: 'runsheetscl',
    component: RunsheetsCL,
    meta: { requiresAuth: true }
  },
  {
    path: '/compraslinea',
    name: 'compraslinea',
    component: ComprasLinea,
    meta: { requiresAuth: true }
  },
  {
    path: '/compraslineaestatus',
    name: 'compraslineaestatus',
    component: ComprasLineaEstatus,
    meta: { requiresAuth: true }
  },
  {
    path: '/asignacionestatus',
    name: 'asignacionestatus',
    component: AsignacionEstatusMasiva,
    meta: { requiresAuth: true }
  },
  {
    path: '/transmisionmasiva',
    name: 'transmisionmasiva',
    component: TransmisionMasiva,
    meta: { requiresAuth: true }
  },
  {
    path: '/importacion',
    name: 'importacion',
    component: Importacion,
    meta: { requiresAuth: true }
  },
  {
    path: '/exportacion',
    name: 'exportacion',
    component: Exportacion,
    meta: { requiresAuth: true }
  },
  {
    path: '/nacional',
    name: 'nacional',
    component: Nacional,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargarguias',
    name: 'cargarguias',
    component: CargarGuias,
    meta: { requiresAuth: true }
  },
  {
    path: '/actualizarpodmasiva',
    name: 'actualizarpodmasiva',
    component: ActualizacionPODMasiva,
    meta: { requiresAuth: true }
  },
  {
    path: '/mailtemplate',
    name: 'mailtemplate',
    component: MailTemplate,
    meta: { requiresAuth: true }
  },
  {
    path: '/rastreo',
    name: 'rastreo',
    component: Rastreo,
    meta: { requiresAuth: true }
  },
  {
    path: '/reporteimp',
    name: 'reporteimp',
    component: ReporteImp,
    meta: { requiresAuth: true }
  },
  {
    path: '/reporteexp',
    name: 'reporteexp',
    component: ReporteExp,
    meta: { requiresAuth: true }
  },
  {
    path: '/reporteseg',
    name: 'reporteseg',
    component: ReporteSeg,
    meta: { requiresAuth: true }
  },
  {
    path: '/reporteimpups',
    name: 'reporteimpups',
    component: ReporteImpUps,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportereclamos',
    name: 'reportereclamos',
    component: ReporteReclamos,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportenacional',
    name: 'reportenacional',
    component: ReporteNacional,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportegeneral',
    name: 'reportegeneral',
    component: ReporteGeneral,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportegeneralcli',
    name: 'reportegeneralcli',
    component: ReporteGeneralCli,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportecotizaciones',
    name: 'reportecotizaciones',
    component: ReporteCotizaciones,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportepickups',
    name: 'reportepickups',
    component: ReportePickups,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargarmanifiestocl',
    name: 'cargarmanifiestocl',
    component: CargarManifiestoCL,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargarpodinfocl',
    name: 'cargarpodinfocl',
    component: CargarPodInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargartarifas',
    name: 'cargartarifas',
    component: CargarTarifas,
    meta: { requiresAuth: true }
  },
  {
    path: '/actualizacionmasivacl',
    name: 'actualizacionmasivacl',
    component: ActualizacionMasivaCL,
    meta: { requiresAuth: true }
  },
  {
    path: '/indicadorescl',
    name: 'indicadorescl',
    component: IndicadoresCL,
    meta: { requiresAuth: true }
  },
  {
    path: '/reportecl',
    name: 'reportecl',
    component: ReporteCL,
    meta: { requiresAuth: true }
  },
  {
    path: '/eliminarmanifiestocl',
    name: 'eliminarmanifiestocl',
    component: EliminarManifiesto,
    meta: { requiresAuth: true }
  },
  {
    path: '/cotizar',
    name: 'cotizar',
    component: Cotizar,
    meta: { requiresAuth: true }
  },
  {
    path: '/coddescuento',
    name: 'coddescuento',
    component: CodigosDescuento,
    meta: { requiresAuth: true }
  },
  {
    path: '/configtasas',
    name: 'configtasas',
    component: ConfiguracionTasas,
    meta: { requiresAuth: true }
  },
  {
    path: '/cargarpreciotramite',
    name: 'cargarpreciotramite',
    component: CargarPrecioTramite,
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
